import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getEmailVerifiedStatus, sendVerificationEmail } from "./EmailVerificationAPI";

export const verifyEmailAsync = createAsyncThunk(
    "emailVerification/verify",
    async (_, { rejectWithValue }) => {
        try {
            const response = await sendVerificationEmail();
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchEmailVerifiedStatus = createAsyncThunk(
    "emailVerification/fetchStatus",
    async (token, { rejectWithValue }) => {
        try {
            const data = await getEmailVerifiedStatus(token);
            return data;
        } catch (error) {
            return rejectWithValue(error.message || "Verification failed");
        }
    }
);

const emailVerificationSlice = createSlice({
    name: "emailVerification",
    initialState: {
        loading: false,
        verified: false,
        error: null,
        status: null, // 'success', 'pending', or 'failed'
        lastResponse: null, // Store the full response for debugging
    },
    reducers: {
        resetVerificationState: (state) => {
            state.loading = false;
            state.verified = false;
            state.error = null;
            state.status = null;
            state.lastResponse = null;
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // verifyEmailAsync cases
            .addCase(verifyEmailAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyEmailAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.lastResponse = action.payload;

                // Check multiple possible success indicators
                if (action.payload.status === "success" || action.payload.verified === true) {
                    state.verified = true;
                    state.status = "success";
                } else {
                    state.verified = false;
                    state.status = "failed";
                }
            })
            .addCase(verifyEmailAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.verified = false;
                state.status = "failed";
            })
            // fetchEmailVerifiedStatus cases
            .addCase(fetchEmailVerifiedStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEmailVerifiedStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.lastResponse = action.payload;
                state.status = action.payload.status;

                // Check multiple possible success indicators
                if (action.payload.status === "success" || action.payload.verified === true) {
                    state.verified = true;
                } else {
                    state.verified = false;
                    // If status is not success but no error, set appropriate error
                    if (action.payload.message) {
                        state.error = action.payload.message;
                    } else if (action.payload.msg) {
                        state.error = action.payload.msg;
                    }
                }
            })
            .addCase(fetchEmailVerifiedStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.verified = false;
                state.status = "failed";
            });
    },
});

export const { resetVerificationState, clearError } = emailVerificationSlice.actions;
export default emailVerificationSlice.reducer;